import React from "react";

function ModalShowRule2Water() {
    return  <table className="rule2water">
      <thead>
        <tr>
          <th>Content</th>
          <th>Minibar (SET UP)</th>
          <th>If Join member ship</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>OTA / Shortime guest</td>
          <td>2 water</td>
          <td>NO fill full minibar / no coin</td>
        </tr>
        <tr>
          <td>Guest have promotion (line, face...)</td>
          <td>2 water</td>
          <td>NO fill full minibar / no coin</td>
        </tr>
        <tr>
          <td>Guest have contract</td>
          <td>Full minibar</td>
          <td>Have AZ coin (staying guest only)</td>
        </tr>
        {/* <tr>
          <td>Sale full price Guest (except OTA)</td>
          <td>Full minibar</td>
          <td>Have AZ coin (staying guest only)</td>
        </tr> */}
        <tr>
          <td>Member ship guest</td>
          <td>Full minibar</td>
          <td>Have AZ coin (staying guest only)</td>
        </tr>
        <tr>
          <td>Special discount from Han’s friend</td>
          <td>Based Han san revervation</td>
          <td>Based Han san revervation</td>
        </tr>
        <tr>
          <td>Discount from indication B.M</td>
          <td>Based on B.M</td>
          <td>Have AZ coin (staying guest only)</td>
        </tr>
        <tr>
          <td>AZ staff book</td>
          <td>2 water</td>
          <td>Have AZ coin (staying guest only)</td>
        </tr>
      </tbody>
    </table>
}

export default ModalShowRule2Water;